import Vue from "vue/dist/vue.esm";
import Vuex from "vuex";
import user from "/store/user";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user
  }
});
